import { getGlossaries } from "../../api/glossaries"

const state = () => ({
	onProcessSettlement: {
		title: "",
		body: "",
	},

	orderDetails: {
		title: "",
		body: "",
	},

	totalPayment: {
		title: "",
		body: "",
	},
})

const actions = {
	async getGlossariesById(context) {
		try {
			const response = await getGlossaries({
				category: "general",
				key: "on-process-settlement",
				language: "en",
			})
		} catch (error) {
		}
	},

	async setOnProcessSettlement(context) {
		try {
			const response = await getGlossaries({
				category: "general",
				key: "on-process-settlement",
				language: "en",
			})

			context.commit("setOnProcessSettlement", response.data)
		} catch (error) {
			console.error(error)
		}
	},

	async setOrderDetails(context) {
		try {
			const response = await getGlossaries({
				category: "general",
				key: "order-details",
				language: "en",
			})

			context.commit("setOrderDetails", response.data)
		} catch (error) {
			console.error(error)
		}
	},
	
	async setTotalPayment(context) {
		try {
			const response = await getGlossaries({
				category: "general",
				key: "total-payment",
				language: "en",
			})

			context.commit("setTotalPayment", response.data)
		} catch (error) {
			console.error(error)
		}
	},
}

const mutations = {
	setOnProcessSettlement(state, payload) {
		state.onProcessSettlement.title = payload.title
		state.onProcessSettlement.body = payload.body
	},

	setOrderDetails(state, payload) {
		state.orderDetails.title = payload.title
		state.orderDetails.body = payload.body
	},
	
	setTotalPayment(state, payload) {
		state.totalPayment.title = payload.title
		state.totalPayment.body = payload.body
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
}
